// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"sz_a bht_b bht_bj","StrollerbaseBanner__hint":"sz_b bht_vh","StrollerbaseBanner__link":"sz_c"};